import { api } from './client';
export interface MarketingView { id: string; name: string; snapshot: MarketingSnapshot; updatedAt: string }
export interface MarketingSnapshot { version: 1; sections: Record<string, unknown> }
export interface MarketingViewScope { brand_id: string; site_id: string; page: string }
export const MAX_MARKETING_SNAPSHOT_BYTES = 1024 * 1024;
export function assertMarketingSnapshotSize(snapshot: MarketingSnapshot) {
  const bytes = new TextEncoder().encode(JSON.stringify(snapshot)).byteLength;
  if (bytes > MAX_MARKETING_SNAPSHOT_BYTES) {
    throw new Error('筛选内容大小为 ' + (bytes / 1024 / 1024).toFixed(2) + ' MiB，超过 1 MiB 上限，请减少筛选内容后保存');
  }
}
export const marketingViewsApi = {
  list: (params: MarketingViewScope) => api.get<{ list: MarketingView[] }>('/marketing-views', { params }),
  save: (params: MarketingViewScope, value: Omit<MarketingView, 'id' | 'updatedAt'>, view?: MarketingView) => {
    assertMarketingSnapshotSize(value.snapshot);
    return view
    ? api.put<{ list: MarketingView[] }>('/marketing-views/' + encodeURIComponent(view.id), { ...value, updatedAt: view.updatedAt }, { params })
    : api.post<{ list: MarketingView[] }>('/marketing-views', value, { params });
  },
  remove: (params: MarketingViewScope, view: MarketingView) => api.delete<{ list: MarketingView[] }>('/marketing-views/' + encodeURIComponent(view.id), { params: { ...params, updated_at: view.updatedAt } }),
  import: (params: MarketingViewScope, views: MarketingView[]) => api.post<{ list: MarketingView[] }>('/marketing-views/import', { views }, { params }),
};
